import { render, staticRenderFns } from "./RequestAuthorization.vue?vue&type=template&id=28522174&"
import script from "./RequestAuthorization.vue?vue&type=script&lang=js&"
export * from "./RequestAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports